import { ChangeEvent, Dispatch, FC, SetStateAction } from "react";
import styled from "styled-components";

const CheckboxLabelHolder = styled.div`
  position: absolute;
  bottom: 16px;
  left: 104px;
  padding: 7px;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  border-radius: 4px;
  transition: opacity ease-out 0.2s;
`;

const CheckboxLabel = styled.label`
  display: block;
  height: 16px;
  width: 16px;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: border-color ease-out 0.2s;
  &:hover {
    border-color: ${({ theme }) => theme.colors.purpleLighter};
  }
`;

const Checkbox = styled.input`
  display: none;
  &:checked + ${CheckboxLabelHolder} {
    opacity: 1;
    > ${CheckboxLabel} {
      background: ${({ theme }) => theme.colors.purple};
      border-color: transparent;
      &:after {
        content: "";
        position: absolute;
        left: 13px;
        top: 10px;
        width: 5px;
        height: 9px;
        border: solid ${({ theme }) => theme.colors.white};
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    }
  }
`;

interface Props {
  index: number;
  isChecked: boolean;
  setSelectedImages: Dispatch<SetStateAction<number[]>>;
  className?: string;
}

const ImageToolCheckbox: FC<Props> = ({
  index,
  isChecked,
  setSelectedImages,
  className,
}) => {
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      return setSelectedImages((prev) => [...prev, index]);
    }
    setSelectedImages((prev) => prev.filter((element) => element !== index));
  };

  return (
    <>
      <Checkbox
        id={`checkbox-${index}`}
        name="thumbnails"
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
      />
      <CheckboxLabelHolder className={className}>
        <CheckboxLabel htmlFor={`checkbox-${index}`} />
      </CheckboxLabelHolder>
    </>
  );
};

export default ImageToolCheckbox;
